import { ToolExecutionStatus } from 'constants/aiChat';

export const editToolHandler = async ({ toolName, parameters, context }) => {
  const { addPendingChange } = context;

  if (!addPendingChange) {
    return {
      success: false,
      status: ToolExecutionStatus.FAILED,
      error: 'Pending changes context not available',
    };
  }

  try {
    switch (toolName) {
      case 'edit_field': {
        const { fieldPath, value, description } = parameters;

        if (!fieldPath) {
          return {
            success: false,
            status: ToolExecutionStatus.FAILED,
            error: 'Field path is required',
          };
        }

        await addPendingChange({
          fieldPath,
          value,
          description: description || `Set ${fieldPath} to ${value}`,
          source: 'ai_chat',
        });

        return {
          success: true,
          status: ToolExecutionStatus.COMPLETED,
          result: {
            fieldPath,
            value,
            message: 'Change added to pending changes',
          },
        };
      }

      case 'edit_fields': {
        const { changes } = parameters;

        if (!changes?.length) {
          return {
            success: false,
            status: ToolExecutionStatus.FAILED,
            error: 'Changes array is required',
          };
        }

        const results = await Promise.all(
          changes.map(async change => {
            const { fieldPath, value, description } = change;

            if (!fieldPath) {
              return {
                fieldPath,
                success: false,
                error: 'Field path is required',
              };
            }

            await addPendingChange({
              fieldPath,
              value,
              description: description || `Set ${fieldPath} to ${value}`,
              source: 'ai_chat',
            });

            return {
              fieldPath,
              value,
              success: true,
            };
          }),
        );

        const successCount = results.filter(r => r.success).length;
        const failCount = results.length - successCount;

        return {
          success: !failCount,
          status: !failCount ? ToolExecutionStatus.COMPLETED : ToolExecutionStatus.FAILED,
          result: {
            results,
            message: `${successCount} change(s) added to pending changes${
              failCount ? `, ${failCount} failed` : ''
            }`,
          },
        };
      }

      default: {
        if (toolName.startsWith('edit_') || toolName.startsWith('update_')) {
          const { fieldPath, value, description } = parameters;

          if (!fieldPath) {
            return {
              success: false,
              status: ToolExecutionStatus.FAILED,
              error: 'Field path is required',
            };
          }

          await addPendingChange({
            fieldPath,
            value,
            description: description || `${toolName}: Set ${fieldPath} to ${value}`,
            source: 'ai_chat',
          });

          return {
            success: true,
            status: ToolExecutionStatus.COMPLETED,
            result: {
              fieldPath,
              value,
              message: 'Change added to pending changes',
            },
          };
        }

        return {
          success: false,
          status: ToolExecutionStatus.FAILED,
          error: `Unknown edit tool: ${toolName}`,
        };
      }
    }
  } catch (error) {
    return {
      success: false,
      status: ToolExecutionStatus.FAILED,
      error: error.message || 'Edit operation failed',
    };
  }
};

export default editToolHandler;
